export default __webpack_public_path__ + "static/media/C6.45ad65e2.svg";